// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 1.99902H7V5.53015C7.20819 5.68425 7.52403 5.893 7.94721 6.1046C8.82493 6.54345 10.1728 6.99902 12 6.99902C13.8272 6.99902 15.1751 6.54345 16.0528 6.1046C16.476 5.893 16.7918 5.68425 17 5.53015V1.99987H23V22.0003H17V16.999H7V21.9994H1V1.99902ZM7 14.999H11V8.95961C9.31362 8.82491 7.99605 8.36508 7.05279 7.89345C7.03506 7.88459 7.01746 7.87572 7 7.86685V14.999ZM13 8.95961V14.999H17V7.86685C16.9825 7.87572 16.9649 7.88459 16.9472 7.89345C16.004 8.36508 14.6864 8.82491 13 8.95961Z"}}]};

const Bridge1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'bridge-1-filled',
    ref,
    icon: element,
  },
));

Bridge1FilledIcon.displayName = 'Bridge1FilledIcon';

export default Bridge1FilledIcon;
